import { createCombinedReducer, createModuleFactory, IModuleFactory } from '@omaze/redux';
import { Reducer } from 'redux';

import { resetEmailCaptureReducer } from './actions/reset-email-capture';
import { resetEmailCaptureWithDelayStartReducer } from './actions/reset-email-capture-with-delay-start';
import { resetEmailCaptureWithDelaySuccessReducer } from './actions/reset-email-capture-with-delay-success';
import { signUpEmailCaptureErrorReducer } from './actions/sign-up-email-capture-error';
import {
    signUpEmailCaptureStartReducer,
} from './actions/sign-up-email-capture-start';
import { signUpEmailCaptureSuccessReducer } from './actions/sign-up-email-capture-success';
import { validateEmailCaptureStartReducer } from './actions/validate-email-capture-start';
import { EMAIL_CAPTURE_NAMESPACE } from './email-capture.factories';
import { ErrorType, IEmailCaptureState, Status } from './email-capture.state';
import { watchResetEmailCaptureWithDelayStart } from './sagas/reset-email-capture-with-delay-start.saga';
import { watchSignUpEmailCapture } from './sagas/sign-up-email-capture.saga';

export const initialEmailCaptureState: IEmailCaptureState = {
    status: Status.INITIAL,
    error: ErrorType.INITIAL,
};

const emailCaptureReducer: Reducer<IEmailCaptureState> = createCombinedReducer<IEmailCaptureState>(
    [
        signUpEmailCaptureStartReducer,
        signUpEmailCaptureErrorReducer,
        signUpEmailCaptureSuccessReducer,
        resetEmailCaptureWithDelayStartReducer,
        resetEmailCaptureWithDelaySuccessReducer,
        resetEmailCaptureReducer,
        validateEmailCaptureStartReducer,
    ],
    initialEmailCaptureState,
);

export const getEmailCaptureModule: IModuleFactory = createModuleFactory<IEmailCaptureState>(
    EMAIL_CAPTURE_NAMESPACE,
    emailCaptureReducer,
    [
        watchSignUpEmailCapture,
        watchResetEmailCaptureWithDelayStart,
    ]
);
